import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=742a29d4&scoped=true&"
import script from "./Board.vue?vue&type=script&setup=true&lang=js&"
export * from "./Board.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a29d4",
  null
  
)

export default component.exports